import HeiGrid from "../../../../Common/components/HeiGrid/HeiGrid";
import styles from "./PendingRequestsGrid.module.scss";

import { pendingRequestsDefaultSorting } from "../../api/models/pendingRequestsDefaultSorting";
import { getPendingRequestsColumns } from "./PendingRequestsGridColumns";
import { usePendingRequestsGrid } from "../../hooks/usePendingRequestsGrid";
import usePageTitle from "../../../../Common/hooks/usePageTitle";
import { SettingsKeys } from "../../../../Common/models/storageSettingsKeys";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface PendingRequestsGridProps {
  searchQuery?: string;
}

const PendingRequestsGrid = ({ searchQuery }: PendingRequestsGridProps) => {
  usePageTitle("Self Onboarding Pending Requests");
  const { fetchGridData } = usePendingRequestsGrid();
  const columns = getPendingRequestsColumns();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Clear the search query parameter from URL after initial load
    if (searchQuery) {
      const timer = setTimeout(() => {
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.delete("search");
        const newSearch = newSearchParams.toString();
        navigate(
          {
            pathname: location.pathname,
            search: newSearch ? `?${newSearch}` : "",
          },
          { replace: true }
        );
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [searchQuery, navigate, location.pathname]);

  return (
    <div className={styles.view}>
      <HeiGrid
        columns={columns}
        fetchGridData={fetchGridData}
        searchPlaceholder="Search name, email, project, role"
        defaultSorting={pendingRequestsDefaultSorting}
        storageSettingsKey={SettingsKeys.PendingRequestsGrid}
        initialSearch={searchQuery}
      />
    </div>
  );
};

export default PendingRequestsGrid;
